import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_DARKER,
  FONT_SIZE_4,
  FONT_WEIGHT_BOLD,
  GRAY_MEDIUM,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  GRAY_LIGHTER_3,
  BORDER_RADIUS,
  FONT_SIZE_6,
  DANGER_COLOR,
} from '../../styles/variables';

export const Container = styled.div`
  background-color: #fff;
  height: 100%;
  position: relative;
`;

export const CloseButton = styled.button`
  width: 22px;
  height: 22px;
  padding: 0;
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background-color: transparent;
  outline: none;
`;

export const CloseIcon = styled.img`
  max-width: 100%;
`;

export const Icon = styled.img`
  width: 100px;
  height: 100px;
  margin: 45px 0 15px;
`;

export const Content = styled.div`
  width: 100%;
  padding: 0px 30px;
  margin: 0 auto;
  text-align: center;
`;

export const Title = styled.h2`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_4, FONT_WEIGHT_BOLD)}
  margin-bottom: 10px;
`;

export const Text = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
`;

export const Footer = styled.div`
  margin-top: 50px;
  height: 80px;
  width: 100%;
  padding: 15px;
  ${flexPosition({ align: 'center' })}
  justify-content: ${({ center }) => (center ? 'center' : 'space-between')};
  background-color: ${GRAY_LIGHTER_3};
`;

export const CancelButton = styled.button`
  height: 45px;
  padding: 5px 15px;
  min-width: 140px;
  background-color: transparent;
  border-radius: ${BORDER_RADIUS};
  border: 1px solid ${GRAY_MEDIUM};
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;

export const DeleteButton = styled.button`
  height: 45px;
  padding: 5px 15px;
  min-width: 140px;
  border: none;
  background-color: ${DANGER_COLOR};
  border-radius: ${BORDER_RADIUS};
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;

export const ErrorContainer = styled.div`
  width: 100%;
  ${Title} {
    color: ${DANGER_COLOR};
  }
`;



// WEBPACK FOOTER //
// ./src/components/DeleteMenuModal/style.js